<template>
  <v-app>
    <v-app-bar app dark :color="admin ? 'secondary' : 'primary'">
      <v-toolbar-title class="body-2">{{ roomId }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="body-2">{{ alias }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text @click="join" v-if="alias != null && !joined && !admin">
        Join
        <i class="mdi mdi-account-multiple"></i>
      </v-btn>
      <v-btn text @click="exit" v-if="joined">
        Exit
        <i class="mdi mdi-account-remove"></i>
      </v-btn>

      <v-btn text @click="logout" v-if="alias != null">
        Logout
        <i class="mdi mdi-logout"></i>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import firebase from "firebase";
import { mapState } from "vuex";
import { database } from "./components/utils-firebase";
export default {
  name: "App",

  data() {
    return {
      admin: false
    };
  },

  computed: {
    roomId: {
      get() {
        return this.$store.state.roomId;
      },
      set(v) {
        this.$store.commit("setRoomId", v);
      }
    },
    ...mapState(["alias", "joined"])
  },

  mounted() {
    console.log("App.mounted")
    if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia) {
      this.$router.push({ name: "NotSupported" });
      return;
    }

    var roomId = this.$route.query.roomid || "test";
    this.$store.commit("setRoomId", roomId);
    firebase.auth().onAuthStateChanged(usr => {
      if (usr) {
        database
          .collection("users")
          .doc(usr.uid)
          .get()
          .then(doc => {
            var person = doc.data();
            this.$store.commit("setUserId", doc.id);
            this.$store.commit("setAlias", person.alias);
            if (person.role == "admin") {
              this.admin = true;
              this.$router.push(
                "TeacherView",
                () => {},
                () => {}
              );
            } else {
              this.$router.push(
                "StudentView",
                () => {},
                () => {}
              );
            }
          });
      }
    });
  },
  methods: {
    join() {
      this.$store.commit("setJoined", true);
    },
    exit() {
      this.$store.commit("setJoined", false);
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.commit("setUserId", null);
          this.$store.commit("setAlias", null);
          this.$store.commit("setJoined", false);
          this.$router.push({ name: "Login" });
        });
    }
  }
};
</script>
